import React, { useEffect, useRef, useState } from "react";
// import './LogosSection.css';
import gsap from "gsap";
import crop2 from "../assets/logos/crop2.png";
import crop4 from "../assets/logos/crop4.png";
import crop6 from "../assets/logos/crop66.png";
import crop8 from "../assets/logos/crop8.png";
import crop00 from "../assets/logos/crop00.jpeg";
import crop88 from "../assets/logos/crop88.png";
import crop44 from "../assets/logos/crop44.png";
import crop66 from "../assets/logos/crop66.png";
import crop200 from "../assets/logos/crop200.png";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";

export default function LogosSection() {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const logoContainerRef = useRef(null);
  const logoElements = useRef([]);
  const [hoveredLogo, setHoveredLogo] = useState(null);

  const addToLogoElements = (el) => {
    if (el && !logoElements.current.includes(el)) {
      logoElements.current.push(el);
    }
  };

 
  const logoData = [
    {
      id: "adp",
      src: { crop2 },
      initialX: -80,
      initialY: -50,
      finalX: 15,
      finalY: 25,
      name: "Green Apple",
      info: "Green apples are rich in fiber, vitamin C, and antioxidants. They're known for their tart flavor and crisp texture. They help improve digestion and boost immune system health.",
    },
    {
      id: "google",
      src: { crop4 },
      initialX: 150,
      initialY: -70,
      finalX: 50,
      finalY: 40,
      name: "Strawberry",
      info: "Strawberries are packed with vitamins, fiber, and high levels of antioxidants. They may have benefits for heart health, blood sugar control, and are naturally low in calories.",
    },
    {
      id: "ms-teams",
      src: { crop6 },
      initialX: 120,
      initialY: -120,
      finalX: 85,
      finalY: 15,
      name: "Orange",
      info: "Oranges are an excellent source of vitamin C, fiber, and antioxidants. They support immune function, skin health, and may help reduce the risk of certain chronic conditions.",
    },
    {
      id: "procreate",
      src: { crop88 },
      initialX: -150,
      initialY: -80,
      finalX: 45,
      finalY: 25,
      name: "Banana",
      info: "Bananas are high in potassium, vitamin B6, and fiber. They support heart health, aid digestion, and provide a natural energy boost. Perfect for pre-workout fuel.",
    },
    {
      id: "grammarly",
      src: { crop00 },
      initialX: 200,
      initialY: 150,
      finalX: 80,
      finalY: 75,
      name: "Blueberry",
      info: "Blueberries are among the most nutrient-dense berries, loaded with antioxidants that may prevent aging and diseases. They improve brain function and memory.",
    },
    {
      id: "atlassian",
      src: { crop200 },
      initialX: -180,
      initialY: 130,
      finalX: 15,
      finalY: 65,
      name: "Watermelon",
      info: "Watermelon is incredibly hydrating as it's 92% water. Rich in vitamins A and C, this summer fruit contains lycopene which may help protect against certain types of cancer.",
    },
    {
      id: "hubspot",
      src: { crop44 },
      initialX: 30,
      initialY: 180,
      finalX: 50,
      finalY: 70,
      name: "Avocado",
      info: "Avocados are nutrient-rich fruits high in healthy fats. They promote heart health, support eye health, and may help with weight management and nutrient absorption.",
    },
    {
      id: "salesforce",
      src: { crop88 },
      initialX: 170,
      initialY: 90,
      finalX: 85,
      finalY: 60,
      name: "Mango",
      info: "Mangoes are packed with vitamins, minerals, and antioxidants. They support eye health, boost immunity, improve digestion, and may help lower cholesterol levels.",
    },
    {
      id: "slack",
      src: { crop66 },
      initialX: -130,
      initialY: 100,
      finalX: 20,
      finalY: 45,
      name: "Pineapple",
      info: "Pineapples contain bromelain, an enzyme with anti-inflammatory properties. They're rich in vitamin C and manganese, supporting immune function and bone health.",
    },
  ];

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

  
    const lenis = new Lenis({
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    
    gsap.set(logoElements.current, {
      scale: 1.6,
      filter: "blur(8px)",
      opacity: 0.5,
    });

   
    logoElements.current.forEach((el, index) => {
      const logo = logoData[index];
      gsap.set(el, {
        xPercent: logo.initialX,
        yPercent: logo.initialY,
      });
    });

    
    logoElements.current.forEach((el, index) => {
      const logo = logoData[index];

      gsap.to(el, {
        xPercent: 0, 
        yPercent: 0,
        scale: 1,
        filter: "blur(0px)",
        opacity: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          end: "center 30%",
          scrub: 1,
        },
        ease: "power2.out",
      });
    });

    lenis.on("scroll", ScrollTrigger.update);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      lenis.destroy();
    };
  }, []);

  const handleMouseEnter = (index) => {
    
    setHoveredLogo(index);
    
    
    const logoPlaceholders = document.querySelectorAll('.logo-placeholder');
    
    
    logoPlaceholders.forEach(placeholder => {
      placeholder.style.zIndex = 1;
    });
    
    
    logoPlaceholders[index].style.zIndex = 10;
  };
  
  const handleMouseLeave = () => {
    setHoveredLogo(null);
    
   
    const logoPlaceholders = document.querySelectorAll('.logo-placeholder');
    logoPlaceholders.forEach(placeholder => {
      placeholder.style.zIndex = 1;
    });
  };
  return (
    <section className="logos-section" ref={sectionRef}>
      <div className="section-content" ref={contentRef}>
        
        <h2>
          Smart Insights
          <br />
          for Your Agricultural Products
        </h2>
        <p>Hover on these products for AI crop insights, details, and recommendations.</p>
        <a href="#" className="cta-button">
          See all integrations
        </a>
      </div>

      <div className="logos-grid">
        <div
          className="logo-placeholder top-left"
          onMouseEnter={() => handleMouseEnter(0)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop2} alt="ADP" />
          </div>
          {hoveredLogo === 0 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[0].name}</h3>
              <p>{logoData[0].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder top-center-left"
          onMouseEnter={() => handleMouseEnter(1)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop4} alt="Procreate" />
          </div>
          {hoveredLogo === 1 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[1].name}</h3>
              <p>{logoData[1].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder top-center-right"
          onMouseEnter={() => handleMouseEnter(2)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop6} alt="Google" />
          </div>
          {hoveredLogo === 2 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[2].name}</h3>
              <p>{logoData[2].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder top-right"
          onMouseEnter={() => handleMouseEnter(3)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop8} alt="MS Teams" />
          </div>
          {hoveredLogo === 3 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[3].name}</h3>
              <p>{logoData[3].info}</p>
            </div>
          )}
        </div>

        {/* Middle row logos */}
        <div
          className="logo-placeholder middle-left"
          onMouseEnter={() => handleMouseEnter(4)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop00} alt="Slack" />
          </div>
          {hoveredLogo === 4 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[4].name}</h3>
              <p>{logoData[4].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder middle-right"
          onMouseEnter={() => handleMouseEnter(5)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop200} alt="Atlassian" />
          </div>
          {hoveredLogo === 5 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[5].name}</h3>
              <p>{logoData[5].info}</p>
            </div>
          )}
        </div>

        {/* Bottom row logos */}
        <div
          className="logo-placeholder bottom-left"
          onMouseEnter={() => handleMouseEnter(6)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop44} alt="HubSpot" />
          </div>
          {hoveredLogo === 6 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[6].name}</h3>
              <p>{logoData[6].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder bottom-center"
          onMouseEnter={() => handleMouseEnter(7)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop88} alt="Salesforce" />
          </div>
          {hoveredLogo === 7 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[7].name}</h3>
              <p>{logoData[7].info}</p>
            </div>
          )}
        </div>

        <div
          className="logo-placeholder bottom-right"
          onMouseEnter={() => handleMouseEnter(8)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ai-badge">
            <i className="fas fa-microchip"></i>
          </div>
          <div className="logo-item" ref={(el) => addToLogoElements(el)}>
            <img src={crop66} alt="Grammarly" />
          </div>
          {hoveredLogo === 8 && (
            <div className="logo-info-tooltip">
              <h3>{logoData[8].name}</h3>
              <p>{logoData[8].info}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
